<template>
    <vue-draggable-resizable
        v-if="type==='text'"
        :w="textMaxWidth"
        :h="textMaxHeight"
        :resizable="false"
        :draggable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
    >
        <v-textarea
            :input_id="objectId"
            tabindex="0"
            :label="currentLabel"
            class="pdftextfield"
            outlined
            rows="1"
            auto-grow
            wrap="off"
            :background-color="bgColorsIdMap[currentDestinationId]"
            hide-details
            :color="colorsIdMap[currentDestinationId]"
            v-on:blur="updateValue"
            v-model="currentValue"
            :maxlength="255"
            :height="textMaxHeight"
            :readonly="isReadOnly"
        >
        </v-textarea>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='select'"
        :w="selectMaxWidth"
        :h="selectMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
    >
        <v-select
          :input_id="objectId"
          v-model="currentValue"
          class="pdfselectfield"
          :items="currentSelectItems"
          :label="currentLabel"
          :background-color="bgColorsIdMap[currentDestinationId]"
          :color="colorsIdMap[currentDestinationId]"
          no-data-text=""
          v-on:change="updateValue"
          outlined
          :height="selectMaxHeight"
          min-height="0"
          hide-details="auto"
          :readonly="isReadOnly"
        >
            <template v-slot:item="{ item }">
               <span class="pdfselectitem">{{ item }}</span>
            </template>
        </v-select>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='checkbox'"
        :w="checkboxMaxWidth"
        :h="checkboxMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
        class-name="checkbox-drag-form vdr"
        :style="{backgroundColor: bgColorsIdMap[currentDestinationId]}"
    >
        <label class="checkbox-input">
            <input 
                type="checkbox"
                tabindex="0"
                :input_id="objectId"
                v-model="currentDefault"
                v-on:change="updateCheckbox"
                :disabled="isReadOnly"
            >
            <span class="checkbox-image"></span>
         </label>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='seal' || type==='square-seal'"
        :key="time"
        :input_id="objectId"
        tabindex="0"
        :w="sealMaxWidth"
        :h="sealMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
        class-name="seal-drag-form vdr"
        :style="bgStyle"
    >
        <v-dialog
            v-model="sealDialog"
            width="fit-content"
        >
            <template v-slot:activator="{ on, attrs}">
                <template v-if="isReadOnly">
                    <v-img
                        :width="sealImageWidth"
                        :height="sealImageHeight"
                        :src="currentSealData"
                        :contain="true"
                        v-show="currentSealData != ''"
                        class="seal-preview"
                    >
                    </v-img>
                    <span
                        class="circle"
                        :style="'border: solid 3px '+colorsIdMap[currentDestinationId]"
                        v-show="currentSealData === ''"
                    >
                    </span>
                </template>
                <template v-else>
                    <v-img
                        :width="sealImageWidth"
                        :height="sealImageHeight"
                        :src="currentSealData"
                        :contain="true"
                        v-show="currentSealData != ''"
                        class="seal-preview"
                        v-bind="attrs"
                        v-on="on"
                    >
                    </v-img>
                    <span
                        class="circle"
                        :style="'border: solid 3px '+colorsIdMap[currentDestinationId]"
                        v-show="currentSealData === ''"
                        v-bind="attrs"
                        v-on="on"
                    >
                    </span>
                </template>
            </template>
            <template>
              <v-tabs v-model="tab">
                <v-tab>印影の選択</v-tab>
                <v-tab>印影の作成</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                <sign-seal-input-dialog-component
                    @cancelSeal="cancelSeal"
                    @registerSeal="registerSeal"
                >
                </sign-seal-input-dialog-component>
                </v-tab-item>
                <v-tab-item>
                    <add-seal-input-dialog-component
                        :type="sealType"
                        :sealText="currentSealText"
                        :direction="currentDirection"
                        @cancelSeal="cancelSeal"
                        @registerSeal="registerSeal"
                        @changeSealText="changeSealText"
                        @changeSealDirection="changeSealDirection"
                        @changeSealType="changeSealType"
                    >
                    </add-seal-input-dialog-component>
                  </v-tab-item>
                </v-tabs-items>
            </template>
        </v-dialog>
    </vue-draggable-resizable>
</template>

<script>
    import { getTextSize } from '../../common/textUtil.js';
    import { getImgInfo } from '../../common/imageUtil.js';
    import AddSealInputDialogComponent from '../contractInput/AddSealInputDialogComponent.vue';
    export default {
        props: [
            'type',
            'destinations',
            'x',
            'y',
            'defaultX',
            'defaultY',
            'value',
            'label',
            'required',
            'defaultValue',
            'destinationId',
            'objectId',
            'page',
            'pdfId',
            'color',
            'colorsIdMap',
            'bgColorsIdMap',
            'selectItems',
            'pdfWidth',
            'pdfHeight',
            'sealText',
            'direction',
            'isReadOnly',
        ],
        components: {
            'add-seal-input-dialog-component': AddSealInputDialogComponent,
        },
        data() {
            return {
                textMaxWidth: 200,
                textMaxHeight: 29.5,
                selectMaxWidth: 200,
                selectMaxHeight:29.5,
                checkboxMaxWidth: 40,
                checkboxMaxHeight: 43,
                sealMaxWidth: 60,
                sealMaxHeight: 60,
                sealImageWidth: 40,
                sealImageHeight: 40,
                currentDestinationId: 0,
                currentValue: '',
                currentLabel: '',
                currentRequired: false,
                currentDefault: false,
                isShowEditArea: false,
                textMenu: false,
                checkboxMenu: false,
                sealMenu: false,
                sealDialog: false,
                currentSealData: '',
                currentSealText: '',
                currentDirection: 0,
                currentX: 0,
                currentY: 0,
                deleted: false,
                currentSelectItems: [],
                tab:null,
                time: new Date().getTime(),
            };
        },
        computed: {
            bgStyle: {
                get() {
                    if (this.currentSealData === ''){
                        return { backgroundColor: this.bgColorsIdMap[this.currentDestinationId] };
                    }else{
                        return {};
                    }
                },
                set() {}
            },
        },
        created: function () {
            this.currentDestinationId = this.destinationId;
            this.currentValue = this.value;
            this.currentSelectItems = this.selectItems? this.selectItems : [];
            this.currentLabel = this.label;
            this.currentRequired = this.required;
            this.currentDefault = this.defaultValue;
            this.currentSealData = this.value? this.value : "";
            this.currentSealText = this.sealText? this.sealText : "";
            this.currentDirection = this.direction? this.direction : 0;
            this.currentX = this.x;
            this.currentY = this.y;
            this.sealType = this.type;
            if (this.type == "seal") {
                let img = getImgInfo(this.currentValue,40)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 25
                })
            }else if(this.type == "square-seal"){
                let img = getImgInfo(this.currentValue,70)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 25
                })
            }
            this.updateInputDetail();
        },
        methods: {
            close: function () {
                this.deleted = true;
                this.$emit('closeElement', this.pdfId, this.page, this.objectId);
            },
            showEditArea: function (isShow) {
                this.isShowEditArea = isShow;
            },
            cancelSeal: function () {
                this.sealDialog = false;
            },
            openSelectSealDialog: function () {
                this.sealDialog = true;
            },
            registerSeal: function (sealData,size,type='seal') {
                this.currentSealData = sealData;
                this.currentValue = sealData;
                this.sealType = type
                this.sealDialog = false;
                if((size + 20) > (this.pdfWidth - this.defaultX)){
                    this.currentX = this.pdfWidth - (size + 20)
                }else{
                    this.currentX = this.defaultX
                }
                if((size + 25) > (this.pdfHeight - this.defaultY)){
                    this.currentY = this.pdfHeight - (size + 25)
                }else{
                    this.currentY = this.defaultY
                }
                this.updateInputDetail();
                let img = getImgInfo(sealData,size)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 20
                })
                this.time = new Date().getTime();
            },
            changeLabel: function (label) {
                this.currentLabel = label;
                this.updateInputDetail();
            },
            changeSealText: function (sealText) {
                this.currentSealText = sealText
                this.updateInputDetail();
            },
            changeSealDirection: function (direction) {
                this.currentDirection = direction
                this.updateInputDetail();
            },
            changeSealType: function (type) {
                this.sealType = type
                this.updateInputDetail();
            },
            addSelectItem: function (item) {
                this.currentSelectItems.push(item)
                this.updateInputDetail()
            },
            changeRequire: function (require) {
                this.currentRequired = require;
                this.updateInputDetail();
            },
            changeDefault: function (defaultValue) {
                this.currentDefault = defaultValue;
                this.updateInputDetail();
            },
            onDrag: function (x, y) {
                this.currentX = x;
                this.currentY = y;
                this.updateInputDetail();
            },
            updateValue: function (e) {
                if (this.type == "select") {
                    this.currentValue = e
                }else{
                    this.currentValue = e.target.value
                }
                this.updateInputDetail();
            },
            updateCheckbox: function (e) {
                if (event.target.checked) {
                    this.currentValue = "checked"
                } else {
                    this.currentValue = ""
                }
                this.updateInputDetail();
            },
            updateInputDetail: function () {
                this.$emit("updateInputDetail",
                    this.page,
                    this.objectId,
                    this.sealType,
                    this.currentDestinationId,
                    this.currentValue,
                    this.currentLabel,
                    this.currentRequired,
                    this.currentDefault,
                    Math.floor(this.currentX),
                    Math.floor(this.currentY),
                    this.defaultX,
                    this.defaultY,
                    this.deleted,
                    this.colorsIdMap[this.currentDestinationId],
                    this.currentSealText,
                    this.currentDirection,
                    this.currentSelectItems,
                );
            }
         },
        watch: {
            currentValue:async function(newVal, oldVal) {
                if (this.type == "text") {
                    await getTextSize(newVal).then( value => {
                      this.textMaxWidth = value.textMaxWidth
                      this.textMaxHeight = value.textMaxHeight
                      this.$el.style.setProperty("--textMaxHeight", value.textMaxHeight + 'px');
                    })
                }
            }
        },
        mounted: function () {
            this.$el.style.setProperty("--textMaxHeight", this.textMaxHeight + 'px')
            this.$el.style.setProperty("--selectMaxHeight", this.selectMaxHeight + 'px')
        },
    };
</script>

<style scoped>
    .circle{
      display: inline-block;
      margin: 9px;
      width: 40px;
      height: 40px;
      text-align:center;
      line-height: 40px;
      border-radius: 50%;
      border: solid 3px blue;
      background-color: #FFF;
    }

    .close-btn {
      position: absolute;
      top: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #ff9999;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .close-btn:hover {
      background: #ff9999;
    }

    .move-btn {
      position: absolute;
      bottom: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #a0e0ff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .move-btn:hover {
      background: #a0e0ff;
    }

    .edit-btn {
      position: absolute;
      bottom: -12px;
      right: 14px;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .edit-btn:hover {
      background: #fff;
    }

    .text-drag-form {
      border: none;
    }

    .checkbox-drag-form {
    }


    .seal-drag-form {
    }

    .seal-preview {
        margin: 9px;
    }
    
    /* PDFに追加するテキストエリアのスタイル(印字に極力合わせるため) */
    .pdftextfield textarea {
        font-size: 10.5px !important;
        line-height: 11.5px !important;
        margin-bottom: 8px;
        letter-spacing: 0.06px;
    }
    
    .checkbox-preview{
        margin-top:4px;
        margin-left:7px;
    }
    
    .pdftextfield::v-deep .v-input__slot {
        min-height:var(--textMaxHeight);
    }
    
    .pdftextfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
    }
    
    .pdftextfield::v-deep .v-label--active {
        transform: translateY(-12px) scale(.75);
    }
    
    .pdfselectfield {
        font-family: 'IPAexゴシック';
    }
    
    .pdfselectfield::v-deep .v-input__slot {
        min-height:var(--selectMaxHeight);
        font-size: 10.5px !important;
    }
    
    .pdfselectfield::v-deep .v-input__append-inner {
        margin-top: 0px !important;
    }
    
    .pdfselectfield::v-deep .v-select__selection--comma {
        margin: 0 !important;
        overflow: hidden;
        max-width: 100%;
        text-overflow: unset;
    }
    
    .pdfselectfield::v-deep .v-select__selections {
        flex-wrap: unset;
    }
    
    .pdfselectitem {
        font-size: 10.5px !important;
    }
    
    .v-select-list::v-deep .theme--light.v-list-item { 
        min-height: 0 !important;
        padding:8px 12px 4px 12px !important;
    }
    
    .pdfselectfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
        color: rgba(0, 0, 0, 0.6) !important
    }
    
    .pdfselectfield::v-deep .v-label--active {
        transform: translateY(-12px) scale(.75);
        color: rgba(0, 0, 0, 0.6) !important
    }
    
    .v-select-list{
        padding:4px !important;
    }
</style>